import { render, staticRenderFns } from "./ForumAddComponent.vue?vue&type=template&id=c6b967e4&scoped=true"
import script from "./ForumAddComponent.vue?vue&type=script&lang=js"
export * from "./ForumAddComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b967e4",
  null
  
)

export default component.exports